
import FormControl from "@material-ui/core/FormControl";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Send from "@material-ui/icons/Send";
import ViewList from "@material-ui/icons/ViewList";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import axios from 'axios';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import ISO6391 from "iso-639-1";
import moment from "moment";
import React from "react";
import Datetime from "react-datetime";
import { connect } from 'react-redux';
import CustomSelect from "components/CustomSelect/CustomSelect"
import "react-table/react-table.css";
import { api_url } from 'redux/config.js';
import { verifyEmail } from "utils/Validate";
import Toast from 'views/Toast/Toast';
import Muted from "components/Typography/Muted"
import { withTranslation } from 'react-i18next';
import Snackbar from 'components/Snackbar/Snackbar';
import SnackbarContent from 'components/Snackbar/SnackbarContent';
import { CallApi } from 'utils/Request';
import TagsInput from 'react-tagsinput'

const styles = {
  ...regularFormsStyle,
  descriptionTextArea: {
    width: "100%",
    height: 150
  },
  emailTags: {
    width: "100%",
    borderBottom: "1px solid #D2D2D2 !important"
  }
};
class SendSurveyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      surveys: [],
      emails: [],
      customMsgs: [],
      selectedSurvey: null,
      campaign_id: this.props.match.params.campaign_id,
      campaign_data: null,
      smsPreview: null,   // { sendable, noPhone, segments, credits, ... } from campaign/sms_preview
      outputData: {
        start_date: moment(new Date()).format('X'),
        additional_emails: [],
        send_type: 'now', // 'daily', 'later',
        send_channel: 'email', // 'sms' | 'both'
        sms_text: '',
        phone_list: '',   // SMS recipients come from a phone list, not the email list
      }
    };
  }

  componentDidMount() {
    this.onLoad();
  }
  loadCampaignData = () => {
    if (this.state.campaign_id === '0' || this.state.campaign_id === '') {
      return
    }
    let self = this;
    const params = {
      id: this.state.campaign_id
    }
    this.props.dispatch({ type: 'LOAD_START' });
    CallApi({
      url: 'campaign/get',
      method: 'get',
      params
    }).then((res) => {
      if (res.success) {
        console.info('=== campaign ===', JSON.stringify(res.data, null, 4))
        const res_data = res.data
        self.setState({
          campaign_data: res_data,
          selectedSurvey: res_data.survey,
          outputData: {
            campaign_name: res_data.campaign_name,
            survey: res_data.survey.id,
            // An SMS-only campaign has no email list at all, so this must not assume one.
            email_list: res_data.email_list ? res_data.email_list.id : '',
            phone_list: res_data.phone_list ? res_data.phone_list.id : '',
            language: res_data.language,
            send_type: res_data.send_type,
            start_date: res_data.start_date,
            message: res_data.message,
            personalized_link: res_data.personalized_link,
            additional_emails: (res_data.additional_emails || []).map(e => typeof e === 'string' ? e : e.email),
            email_sender: res_data.email_sender,
            email_subject: res_data.email_subject,
            send_channel: res_data.send_channel || 'email',
            sms_text: res_data.sms_text || ''
          }
        }, () => self.refreshSmsPreview());
      } else {
        Toast(400, res.error);
      }
    }).finally(() => {
      self.props.dispatch({ type: 'LOAD_END' });
    })
  }
  normalize = (response) => {
    const surveys = response[0].data.data.map((item) => ({ id: item.id, _id: item.id, main: item.main }));
    const selectedSurvey = surveys[0] ? surveys[0] : null
    // Both kinds of list arrive together; `kind` is what lets the form offer each channel only the
    // lists it can actually send to.
    const emails = response[1].data.data.map((item) => ({
      label: item.name,
      value: item.id,
      kind: item.kind === 'phone' ? 'phone' : 'email'
    }))
    const customMsgs = response[2].data.data.map((item) => ({
      label: item.name,
      value: item.message
    }))
    this.setState({
      surveys, emails, customMsgs, selectedSurvey,
      outputData: {
        ...this.state.outputData,
        language: surveys[0].main[0].language,
        survey: selectedSurvey.id
      }
    })
    setTimeout(() => {
      this.loadCampaignData()
    }, 0);
  }
  onLoad = () => {
    let self = this;
    const header = 'Bearer '.concat(this.props.user.token);
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.props.dispatch({ type: 'LOAD_START' });
    const ps_survey = axios({ url: api_url + 'survey/all_active', method: 'get', headers })
    const ps_emaillist = axios({ url: api_url + 'emaillist/all', method: 'get', headers })
    const ps_custommessage = axios({ url: api_url + 'custommessage/all', method: 'get', headers })
    Promise.all([ps_survey, ps_emaillist, ps_custommessage])
      .then(function (response) {
        self.normalize(response)
        self.props.dispatch({ type: 'LOAD_END' });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: 'LOAD_END' });
        if (!errors.response) {
          Toast(500);
          return;
        }
        Toast(errors.response.status);
      });
  };
  isEmail = (inputText) => {
    return verifyEmail(inputText)
  }
  setFormData = (name, value) => {
    let outputData = { ...this.state.outputData };
    outputData[name] = value;
    this.setState({ outputData })
  }
  validateForm = () => {
    const { t } = this.props
    const data = this.state.outputData;

    if (!data.survey || data.survey.length === 0) {
      Toast(400, t('Please enter survey')); return false;
    }
    if (!data.campaign_name || data.campaign_name.length === 0) {
      Toast(400, t('Please enter campaign name')); return false;
    }
    // Each channel needs recipients of its own kind, so what counts as "no recipients" depends on
    // the channel rather than always meaning the email list.
    const channel = data.send_channel || 'email';
    const usesEmail = channel === 'email' || channel === 'both';
    const usesSms = channel === 'sms' || channel === 'both';
    if (usesEmail && !data.email_list && data.additional_emails.length === 0) {
      Toast(400, t('Please enter email list or emails')); return false;
    }
    if (usesSms && !data.phone_list) {
      Toast(400, t('Please choose a phone list')); return false;
    }
    if (usesEmail) {
      if (!data.email_sender || !verifyEmail(data.email_sender)) {
        Toast(400, t('Please enter email sender')); return false;
      }
      if (!data.email_subject || data.email_subject.length === 0) {
        Toast(400, t('Please enter email subject')); return false;
      }
      if (!data.personalized_link || data.personalized_link.length === 0) {
        Toast(400, t('Please enter personalized link')); return false;
      }
    }
    if (usesSms) {
      if (!data.sms_text || !data.sms_text.trim()) {
        Toast(400, t('Please enter the SMS text')); return false;
      }
      if (data.sms_text.indexOf('{link}') < 0) {
        Toast(400, t('The SMS text must contain {link} — that is where the survey link goes.')); return false;
      }
    }
    if (!data.language || data.language.length === 0) {
      Toast(400, t('Please enter language')); return false;
    }
    return true;
  }

  channelUsesEmail = () => {
    const c = this.state.outputData.send_channel || 'email';
    return c === 'email' || c === 'both';
  }
  channelUsesSms = () => {
    const c = this.state.outputData.send_channel || 'email';
    return c === 'sms' || c === 'both';
  }

  // Ask the server what this campaign would cost: how many recipients are reachable, how many have
  // no usable phone, and how many segments in total (segments, not messages, are what gets billed).
  refreshSmsPreview = () => {
    const d = this.state.outputData;
    const channel = d.send_channel || 'email';
    if (channel === 'email' || !d.phone_list) { this.setState({ smsPreview: null }); return; }
    CallApi({
      url: 'campaign/sms_preview', method: 'post',
      data: { phone_list_id: d.phone_list, sms_text: d.sms_text || '' },
    }).then(res => {
      if (res && res.success) this.setState({ smsPreview: res.data });
    }).catch(() => { });
  }
  // Segment counting mirrors the operator's rules: any non-GSM-7 character (Greek, emoji, curly
  // quote) turns the whole message into Unicode, cutting the per-segment budget from 160 to 70.
  // Shown live so nobody discovers the doubled cost on the invoice.
  smsStats = (text) => {
    const GSM7 = '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?'
      + '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
    const EXT = '^{}\\[~]|€';
    // {link} becomes a short URL of a known shape — measure that, not the placeholder.
    const sample = String(text || '').split('{link}').join('https://gooreports.com/s/Ab3xK9p');
    let unicode = false;
    for (const ch of sample) { if (GSM7.indexOf(ch) < 0 && EXT.indexOf(ch) < 0) { unicode = true; break; } }
    let len = 0;
    if (unicode) len = Array.from(sample).length;
    else for (const ch of sample) len += EXT.indexOf(ch) >= 0 ? 2 : 1;
    const per = unicode ? 70 : 160, cont = unicode ? 67 : 153;
    const segments = len === 0 ? 1 : (len <= per ? 1 : Math.ceil(len / cont));
    return { unicode, length: len, segments, per };
  }

  // Copy a placeholder to the clipboard. The modern API needs a secure context and a permission
  // that can be refused, so fall back to appending the code straight into the SMS text — the point
  // is that the user ends up with it in the message either way.
  copyPlaceholder = (code) => {
    const { t } = this.props;
    const done = () => Toast(200, t('Copied — paste it in the message'));
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, () => this.appendPlaceholder(code));
        return;
      }
    } catch (e) { /* fall through */ }
    this.appendPlaceholder(code);
  }
  appendPlaceholder = (code) => {
    const { t } = this.props;
    const text = this.state.outputData.sms_text || '';
    this.setFormData('sms_text', text + (text && !/\s$/.test(text) ? ' ' : '') + code);
    Toast(200, t('Added to the end of the message'));
  }

  renderChannelSection = () => {
    const { t } = this.props;
    const { outputData, smsPreview } = this.state;
    const channel = outputData.send_channel || 'email';
    const usesSms = channel === 'sms' || channel === 'both';
    const st = this.smsStats(outputData.sms_text);
    const chanBtn = (key, label) => (
      <button type="button" key={key} onClick={() => {
        this.setFormData('send_channel', key);
        setTimeout(this.refreshSmsPreview, 0);
      }} style={{
        border: '1px solid ' + (channel === key ? '#2f9e44' : '#cfd8d3'),
        background: channel === key ? '#2f9e44' : '#fff',
        color: channel === key ? '#fff' : '#5d6d66',
        fontFamily: 'inherit', fontSize: 13.5, fontWeight: 600, padding: '8px 16px',
        borderRadius: 8, cursor: 'pointer', marginRight: 8,
      }}>{label}</button>
    );
    return (
      <div style={{ border: '1px solid #e2e8e4', borderRadius: 12, padding: '14px 16px', margin: '10px 0 18px', background: '#fafdfb' }}>
        <div style={{ fontSize: 12, color: '#8a988f', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 8 }}>
          {t('Send via')}
        </div>
        {chanBtn('email', '✉ Email')}
        {chanBtn('sms', '💬 SMS')}
        {chanBtn('both', t('Both'))}
        {channel === 'sms' &&
          <span style={{
            display: 'inline-block', marginLeft: 4, fontSize: 11, fontWeight: 700,
            letterSpacing: '.05em', padding: '4px 10px', borderRadius: 99,
            background: '#e8f1fb', color: '#245b96', verticalAlign: 'middle',
          }}>
            📱 {t('MOBILE CAMPAIGN')}
          </span>}

        {usesSms &&
          <div style={{ marginTop: 14 }}>
            <label style={{ fontSize: 12, color: '#8a988f', fontWeight: 600 }}>{t('SMS text')}</label>
            <textarea
              value={outputData.sms_text || ''}
              onChange={e => { this.setFormData('sms_text', e.target.value); }}
              onBlur={this.refreshSmsPreview}
              placeholder={t('e.g. Thank you for staying with us! Tell us how it was: {link}')}
              style={{
                width: '100%', minHeight: 80, fontFamily: 'inherit', fontSize: 14, padding: '10px 12px',
                border: '1px solid #cfd8d3', borderRadius: 8, marginTop: 4, resize: 'vertical',
              }} />

            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center', marginTop: 6, fontSize: 12.5 }}>
              <span style={{ color: st.segments > 1 ? '#c0392b' : '#5d6d66', fontWeight: 600 }}>
                {st.length} {t('chars')} · {st.segments} {t('segment(s)')}
                {st.unicode ? ` · Unicode (${st.per}/${t('segment')})` : ` · GSM-7 (${st.per}/${t('segment')})`}
              </span>
            </div>

            {/* "Placeholders: {link} {name} {title}" told a developer everything and a hotelier
                nothing. Each one is now a button that copies itself and says, in words, what it
                puts in the message. */}
            <div style={{ marginTop: 8 }}>
              <div style={{ fontSize: 12.5, color: '#8a988f', marginBottom: 4 }}>
                {t('Click to copy, then paste where you want it to appear in the message:')}
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {[
                  { code: '{link}', label: t('Survey link'), help: t('The link to the questionnaire. Required — without it the message has no purpose.') },
                  { code: '{name}', label: t('Guest name'), help: t('The name of the recipient, as stored in the phone list. Left empty when unknown.') },
                  { code: '{title}', label: t('Title (Mr / Mrs)'), help: t('The title of the recipient, as stored in the phone list. Left empty when unknown.') },
                ].map(v => (
                  <button key={v.code} type="button" title={v.help}
                    onClick={() => this.copyPlaceholder(v.code)}
                    style={{
                      border: '1px solid #cfd8d3', background: '#fff', borderRadius: 8,
                      padding: '6px 10px', cursor: 'pointer', fontFamily: 'inherit',
                      textAlign: 'left', lineHeight: 1.3,
                    }}>
                    <div style={{ fontFamily: 'monospace', fontSize: 12.5, color: '#245b96' }}>
                      📋 {v.code}
                    </div>
                    <div style={{ fontSize: 11.5, color: '#5d6d66' }}>{v.label}</div>
                  </button>
                ))}
              </div>
            </div>

            {st.segments > 1 &&
              <div style={{ marginTop: 6, fontSize: 12.5, color: '#c0392b' }}>
                ⚠ {t('This message costs')} {st.segments}× {t('per recipient. Shorten it to fit one segment.')}
              </div>}

            {smsPreview &&
              <div style={{ marginTop: 12, background: '#f2f9f4', border: '1px solid #cfe6d7', borderRadius: 10, padding: '10px 14px', fontSize: 13, color: '#2f6b4f' }}>
                <b>{t('Cost preview')}:</b>{' '}
                {smsPreview.sendable} {t('recipients with a phone')} · <b>{smsPreview.segments} {t('SMS segment(s)')}</b>
                {/* Credits only exist when we bill the account. On a bring-your-own-account setup
                    the provider invoices the hotel directly and nothing here is ever charged, so
                    showing "you have 0" and refusing to send was simply wrong. */}
                {smsPreview.metered && <span> ({t('you have')} {smsPreview.credits} {t('credits')})</span>}
                {!smsPreview.metered &&
                  <div style={{ color: '#5d6d66', marginTop: 3 }}>
                    {t('Billed by your own provider account.')}
                  </div>}
                {smsPreview.noPhone > 0 &&
                  <div style={{ color: '#8a988f', marginTop: 3 }}>
                    {smsPreview.noPhone} {t('recipients have no usable phone and will be skipped.')}
                  </div>}
                {smsPreview.metered && smsPreview.segments > smsPreview.credits &&
                  <div style={{ color: '#c0392b', fontWeight: 600, marginTop: 3 }}>
                    {t('Not enough credits — only part of the list will be sent.')}
                  </div>}
                {smsPreview.max_per_campaign > 0 && smsPreview.sendable > smsPreview.max_per_campaign &&
                  <div style={{ color: '#8a988f', marginTop: 3 }}>
                    {t('Per-campaign cap')}: {smsPreview.max_per_campaign}
                  </div>}
              </div>}
          </div>}
      </div>
    );
  }

  sendSurvey = () => {
    if (!this.validateForm()) return

    let data = {
      ...this.state.outputData,
      campaign_id: this.state.campaign_id
    };
    let self = this;
    const url = api_url + `campaign/send_survey`;
    const header = 'Bearer '.concat(this.props.user.token);
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.props.dispatch({ type: 'LOAD_START' });
    axios({
      url,
      method: 'post',
      headers,
      data
    })
      .then(function (response) {
        if (response.data.success) {
          self.props.history.push('/campaign/campaign')
        } else {
          Toast(400, response.data.error)
        }
        self.props.dispatch({ type: 'LOAD_END' });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: 'LOAD_END' });
        if (!errors.response) {
          Toast(500);
          return;
        }
        Toast(errors.response.status);
      });
  }
  getSurveysOfSelectedLang = () => {
    const surveys = this.state.surveys.map(item => {
      const main = item.main.filter(mi => mi.language === this.state.outputData.language)[0]
      if (main) {
        return {
          label: main.title,
          value: item.id
        }
      } else {
        return {
          label: item.main[0].title,
          value: item.id
        }
      }
    })
    return surveys
  }
  getAvailableLanguages = () => {
    const selectedSurvey = this.state.selectedSurvey
    const availableLanguages = selectedSurvey.main.map(item => {
      return {
        value: item.language,
        label: ISO6391.getName(item.language)
      }
    })
    return availableLanguages
  }
  onChangeCurrentSurvey = (id) => {
    const { surveys, outputData } = this.state
    const newSurvey = surveys.filter(item => item.id === id)[0]
    this.setState({
      selectedSurvey: newSurvey,
      outputData: {
        ...outputData,
        survey: id
      }
    })
  }
  render() {
    const { classes, t } = this.props;
    const { selectedSurvey, outputData, campaign_data } = this.state
    if (!selectedSurvey) {
      return <Muted><h3>...</h3></Muted>
    }
    const surveysOfCurrentLanguage = this.getSurveysOfSelectedLang()
    const availableLanguages = this.getAvailableLanguages()

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12}>
            <Card>
              <CardHeader color="success" icon>
                <CardIcon color="success">
                  <ViewList />
                </CardIcon><h4 className={classes.cardIconTitle}>{t('SEND SURVEY LINK')}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} md={12}>
                    <CustomInput
                      labelText={t('Campaign name')}
                      id="campaignname"
                      formControlProps={{
                        label: 'Test',
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (e) => this.setFormData('campaign_name', e.target.value),
                        value: outputData.campaign_name
                      }}
                    />
                    <br />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomSelect
                      onChange={updated => {
                        this.onChangeCurrentSurvey(updated.value)
                      }}
                      placeholder={t('Survey')}
                      options={surveysOfCurrentLanguage}
                      value={surveysOfCurrentLanguage.filter(item => item.value === selectedSurvey.id)[0]}
                    />
                    <br />
                    {/* Each channel gets only the lists it can send to: an email campaign cannot
                        reach a list of numbers, and an SMS campaign cannot reach a list of
                        addresses. Showing both together is how a customer picks the wrong one. */}
                    {this.channelUsesEmail() &&
                      <React.Fragment>
                        <CustomSelect
                          onChange={selvalue => {
                            this.setFormData('email_list', selvalue.value)
                          }}
                          placeholder={t('E-mail List')}
                          options={this.state.emails.filter(l => l.kind !== 'phone')}
                          value={this.state.emails.filter(email => email.value == outputData.email_list)[0]}
                          isDisabled={campaign_data}
                        />
                        <br />
                      </React.Fragment>}
                    {this.channelUsesSms() &&
                      <React.Fragment>
                        <CustomSelect
                          onChange={selvalue => {
                            this.setFormData('phone_list', selvalue.value)
                            setTimeout(() => this.refreshSmsPreview(), 0)
                          }}
                          placeholder={t('Phone List')}
                          options={this.state.emails.filter(l => l.kind === 'phone')}
                          value={this.state.emails.filter(l => l.value == outputData.phone_list)[0]}
                          isDisabled={campaign_data}
                        />
                        <br />
                        {this.state.emails.filter(l => l.kind === 'phone').length === 0 &&
                          <div style={{ fontSize: 13, color: '#8a6d1e', marginTop: -8, marginBottom: 10 }}>
                            {t('No phone lists yet — create one under Email lists.')}
                          </div>}
                      </React.Fragment>}
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomSelect
                      onChange={selvalue => {
                        this.setState({
                          outputData: {
                            ...outputData,
                            language: selvalue.value
                          }
                        })
                      }}
                      placeholder={t('Language')}
                      options={availableLanguages}
                      value={{ value: outputData.language, label: ISO6391.getName(outputData.language) }}
                    />
                    <br />
                    <CustomSelect
                      onChange={selvalue => {
                        this.setFormData('message', selvalue.value)
                      }}
                      placeholder={t('Custom Message')}
                      options={this.state.customMsgs}
                    />
                    <br />

                  </GridItem>

                  <GridItem xs={12} md={12}>
                    {this.renderChannelSection()}
                  </GridItem>

                  <GridItem xs={12} md={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.outputData.send_type === "now"}
                          tabIndex={-1}
                          onClick={() => this.setFormData("send_type", 'now')}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked
                          }}
                        />
                      }
                      classes={{
                        label: classes.label
                      }}
                      label={t('Send campaign right now')}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.outputData.send_type === "daily"}
                          tabIndex={-1}
                          onClick={() => this.setFormData("send_type", 'daily')}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked
                          }}
                        />
                      }
                      classes={{
                        label: classes.label
                      }}
                      label={t('Send campaign every day')}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.outputData.send_type === "later"}
                          tabIndex={-1}
                          onClick={() => this.setFormData("send_type", 'later')}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked
                          }}
                        />
                      }
                      classes={{
                        label: classes.label
                      }}
                      label={t('Send campaign later')}
                    />
                    {

                      this.state.outputData.send_type === 'later' && <FormControl fullWidth>
                        <div>
                          {t('Send date')}
                        </div>
                        <Datetime
                          onChange={selvalue => {
                            this.setFormData('start_date', selvalue.format('X'))
                          }}
                          closeOnSelect={true}
                          className={classes.customInput}
                          timeFormat={false}
                          dateFormat="DD/MM/YYYY"
                          inputProps={{ placeholder: t('Start date') }}
                          value={moment.unix(Number(outputData.start_date))}
                        />
                      </FormControl>
                    }
                    <br />
                  </GridItem>
                  {/* Everything from here to the subject is the email message: the rich-text body,
                      its saved-message name, the anchor text of the link, extra addresses, sender
                      and subject. None of it applies to an SMS, whose entire content is the text
                      box above, so a mobile campaign hides the lot instead of showing a page of
                      fields the user must know to ignore. */}
                  {this.channelUsesEmail() && <React.Fragment>
                  <GridItem xs={12} md={12}>
                    <h5>&nbsp;</h5>
                    <p>{t('Message')}</p>
                    <SnackbarContent
                      open
                      message={<div>
                        <div><b>#{t('title')}</b>: {t('Email Title')}</div>
                        <div><b>#{t('name')}</b>: {t('Email Name')}</div>
                        <div><b>#{t('survey')}</b>: {t('Survey Name')}</div>
                      </div>}
                    />
                    <ReactQuill
                      value={this.state.outputData.message || ''}
                      onChange={(value) => this.setFormData('message', value)}
                      modules={{
                        toolbar: [
                          [{ 'header': [1, 2, 3, false] }],
                          ['bold', 'italic', 'underline', 'link'],
                          [{ 'align': [] }],
                          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                          ['clean']
                        ]
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      labelText={t('Name for Message to save')}
                      id="nameformessagetosave"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (e) => this.setFormData('message_name', e.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      labelText={t('Personalize the link')}
                      id="nameformessagetosave"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (e) => this.setFormData('personalized_link', e.target.value),
                        value: outputData.personalized_link
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={12}>
                    <p>{t('Enter E-mails (optional)')} </p>
                    <div className={classes.emailTags}>
                      <TagsInput
                        value={this.state.outputData.additional_emails}
                        onlyUnique={true}
                        onChange={(tags) => this.setFormData('additional_emails', tags)}

                        validate={(inputText) => this.isEmail(inputText)}
                        tagProps={{ className: "react-tagsinput-tag info" }}
                        inputProps={{
                          placeholder: t('email'),
                        }}
                      />
                    </div>
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      labelText={t('E-mail sender')}
                      id="emailsender"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (e) => this.setFormData('email_sender', e.target.value),
                        value: outputData.email_sender
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      labelText={t('Subject')}
                      id="subject"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (e) => this.setFormData('email_subject', e.target.value),
                        value: outputData.email_subject
                      }}
                    />
                  </GridItem>
                  </React.Fragment>}
                </GridContainer>
              </CardBody>
              <CardFooter>
                {!campaign_data && <Button fullWidth color="info" size="lg" onClick={() => this.sendSurvey()}>
                  <Send />
                  {t('Send your survey')}
                </Button>}
                {campaign_data && <Button fullWidth color="info" size="lg" onClick={() => this.sendSurvey()}>
                  <Send />
                  {t('Update')}
                </Button>}
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}


const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(SendSurveyPage)));